import React, { createContext, useState, useEffect } from "react";

const AppContext = createContext();

function AppContextProvider(props) {
  const [isNoteFormOpen, setIsNoteFormOpen] = useState(false);
  const [isLocalNotesDialogOpen, setIsLocalNotesDialogOpen] = useState(false);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [previousLocation, setPreviousLocation] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [user, setUser] = useState(null);
  const [isDarkMode, setIsDarkMode] = useState(() => {
    // Detect system preference
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  // Listen for system theme changes
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

    const handleChange = (e) => {
      setIsDarkMode(e.matches);
    };

    // Add listener for theme changes
    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  const handleNoteFormOpen = (val) => {
    setIsNoteFormOpen(val);
  };

  const handleLocalNotesDialogOpen = (val) => {
    setIsLocalNotesDialogOpen(val);
  };

  const handleLocationChange = (newLocation) => {
    if (!previousLocation || distance(previousLocation, newLocation) >= 100) {
      setCurrentLocation(newLocation);
      setPreviousLocation(newLocation);
    }
  };

  const distance = (loc1, loc2) => {
    // Calculate distance between two locations in meters
    const R = 6371e3; // Earth's radius in meters
    const lat1 = loc1.lat * Math.PI / 180;
    const lat2 = loc2.lat * Math.PI / 180;
    const deltaLat = (loc2.lat - loc1.lat) * Math.PI / 180;
    const deltaLng = (loc2.lng - loc1.lng) * Math.PI / 180;

    const a = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
              Math.cos(lat1) * Math.cos(lat2) *
              Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
  };

  const contextValues = {
    isNoteFormOpen,
    handleNoteFormOpen,
    currentLocation,
    handleLocationChange,
    isLocalNotesDialogOpen,
    handleLocalNotesDialogOpen,
    anchorEl,
    setAnchorEl,
    user,
    setUser,
    isDarkMode,
  };

  return (
    <AppContext.Provider value={contextValues}>
      {props.children}
    </AppContext.Provider>
  );
}


export { AppContext, AppContextProvider };
